export const CART_REFRESH_EVENT = 'store-cart:refresh';

export function dispatchCartRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CART_REFRESH_EVENT));
}
